<div class="border rounded p-3 bg-light">
  <h2 class="h5 mb-2">Ativacao do terminal</h2>
  <p class="text-secondary mb-3">Informe o codigo de ativacao cadastrado pelo administrador para liberar este equipamento.</p>
  <form class="d-grid gap-2" (ngSubmit)="ativarTerminal.emit()">
    <input
      class="form-control form-control-lg text-center"
      name="codigoAtivacaoTerminal"
      [ngModel]="codigoAtivacao"
      (ngModelChange)="codigoAtivacaoChange.emit($event)"
      placeholder="Codigo de ativacao"
      autocomplete="off"
      required>
    <button class="btn btn-success btn-lg" [disabled]="ativandoTerminal">
      {{ ativandoTerminal ? 'Ativando...' : 'Ativar terminal' }}
    </button>
  </form>
</div>
